import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import { ConfirmAppointmentModel } from '../../models/confirm_appointment_model';
import { IConfirmAppointmentReminderOptions } from '../../models/confirm_appointment_model';
import { AppointmentsConfirmQuery } from '../../queries/appointments_confirm_query';
import { UpcomingAppointmentsQuery } from '../../queries/upcoming_appointments_query';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import { AppointmentRemindersServant } from '../../servants/appointment_reminders_servant';
import MyAppointmentStateService from '../../services/my_appointment_state_service';
import { IStudentService } from '../../types/appointment_interfaces';
import { IOrganizer } from '../../types/appt_interfaces';

export interface IAppointmentConfirmationData {
  start_timestamp: string;
  end_timestamp: string;
  organizers: IOrganizer[];
  appointment_type: string;
  location: any;
  is_cancelled: boolean;
  student_services: IStudentService[];
}

interface IElement {
  offsetTop: number;
}

export class AppointmentsConfirmController {
  phoneNumber: string;
  email: string;
  phoneNumberPattern: RegExp;
  appointmentData: any;
  comments: string;
  isSendEmail: boolean;
  isSendEmailEnabled: boolean;
  isSendTextMessageEnabled: boolean;
  isSendTextMessage: boolean;
  isCampaignAppointment: boolean = false;
  sendEmailIcon: string;
  sendTextIcon: string;
  isApptSchedulingInProgress: boolean = false;

  constructor(
    private ngConfirmAppointmentModel: ConfirmAppointmentModel,
    private ngAppointmentsConfirmQuery: AppointmentsConfirmQuery,
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    public navigateContactInfo: any,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration,
    private ngAppointmentButtonServant: AppointmentButtonServant,
    private clearAllAppointmentsDataSourcesCommand: ICommand,
    private loadUpcomingAppointmentsCommand: ICommand,
    private ngAppointmentRemindersServant: AppointmentRemindersServant,
    private appointmentsConfirmationCommand: ICommand,
    private ngMyAppointmentsStateService: MyAppointmentStateService
  ) {
    this.phoneNumber =
      this.navigateContactInfo.model.phoneNumber.target ||
      this.ngUpcomingAppointmentsQuery.result().studentInfo.cell_phone ||
      '';
    this.ngConfirmAppointmentModel.savePhoneNumber(this.phoneNumber);
    this.email = this.ngUpcomingAppointmentsQuery.result().studentInfo.email || '';
    this._initializeConfirmationReminders(this.ngConfirmAppointmentModel.confirmAppointmentReminderOptions);
    this.appointmentData = this.createAppointmentCardData();
    this.confirmAppointment = this.confirmAppointment.bind(this);
  }

  $onInit() {
    this.isApptSchedulingInProgress = false;
    this.ngAppointmentButtonServant.configButton({
      buttonText: 'Confirm Appointment',
      isDisabled: this.isApptSchedulingInProgress,
      action: () => this.confirmAppointment()
    });
    this.ngMyAppointmentsStateService.stateLoaded();
  }

  changeSendEmailStatus(event: JQueryEventObject) {
    const status = !this.isSendEmail;
    this.isSendEmail = status;
    this.ngConfirmAppointmentModel.saveSendEmail(status);
  }

  changeSendTextMessageStatus(event: JQueryEventObject) {
    this.isSendTextMessage = !this.isSendTextMessage;
    if (!this.isSendTextMessage) {
      this.ngAppointmentButtonServant.isDisabled = false;
    }
    this.ngConfirmAppointmentModel.saveSendTextMessage(this.isSendTextMessage);
  }

  saveComments(event: JQueryEventObject): void {
    this.ngConfirmAppointmentModel.saveComments(_4.get(event.target, 'value', ''));
  }

  savePhoneNumber(event: JQueryEventObject) {
    const phoneNumber = _4.get(event.target, 'value', '').replace(/(\()|(\))|(-)|(\s+)/g, '');
    this.ngAppointmentButtonServant.isDisabled = !(phoneNumber.length > 9 && phoneNumber.length < 12);
    this.ngConfirmAppointmentModel.savePhoneNumber(phoneNumber);
  }

  private _initializeConfirmationReminders(
    confirmAppointmentReminderOptions: IConfirmAppointmentReminderOptions
  ): void {
    this.isSendEmail = confirmAppointmentReminderOptions.isSendEmail;
    this.isSendTextMessage = confirmAppointmentReminderOptions.isSendTextMessage;
    this.isSendEmailEnabled = confirmAppointmentReminderOptions.isSendEmailReminderEnabled;
    this.isSendTextMessageEnabled = confirmAppointmentReminderOptions.isSendTextMessageReminderEnabled;
  }

  createAppointmentCardData(): IAppointmentConfirmationData {
    const apptConfirmData: any = this.ngAppointmentsConfirmQuery.result;
    this.isCampaignAppointment = apptConfirmData.isCampaignAppointment;
    const selectedLocation = { id: 0, name: apptConfirmData.location };
    return {
      start_timestamp: apptConfirmData.startTimeUnix,
      end_timestamp: apptConfirmData.endTimeUnix,
      organizers: [apptConfirmData.organizer],
      appointment_type: 'One Time Appointment',
      location: selectedLocation,
      is_cancelled: false,
      student_services: [apptConfirmData.selectedService]
    };
  }

  confirmAppointment(): void {
    if (this.isApptSchedulingInProgress) {
      return;
    }
    this.isApptSchedulingInProgress = true;
    this.ngAppointmentButtonServant.isDisabled = this.isApptSchedulingInProgress;
    this.appointmentsConfirmationCommand().then(
      (response: any) => {
        this.ngAppointmentRemindersServant.trigger.success('Appointment Scheduled.');
        this.loadUpcomingAppointmentsCommand();
        this.ngAppointmentButtonServant.isDisabled = this.isApptSchedulingInProgress = false;
        this.ngMyAppointmentsStateService.goToScheduled();
        this.ngAppointmentButtonServant.setDefaults();
      },
      () => {
        this.ngAppointmentButtonServant.isDisabled = this.isApptSchedulingInProgress = false;
        this.ngAppointmentRemindersServant.trigger.warn('Unable to schedule appointment.');
      }
    );
  }
}

angular
  .module('capability-ng-appointments')
  .controller('ngAppointmentsConfirmController', AppointmentsConfirmController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/confirm/confirm.ts